import {
  CLOSE_WARN_DELETE_JOURNAL,
  CLOSE_USER_WORKSHIFT_SNACKBAR,
  GET_BILLABLE_HOUR_USER,
  GET_BILLABLE_HOUR_USER_SUCCESS,
  GET_EMPLOYER_WORKSHIFT_SUCCESS,
  GET_JOURNAL_SUCCESS,
  GET_WORKSHIFT_USER,
  GET_WORKSHIFT_USER_SUCCESS,
  WARN_DELETE_JOURNAL,
  LOCATION_CHANGE,
  REQUEST_EDIT_ACTUAL_HOUR_FAILED,
  REQUEST_EDIT_ACTUAL_HOUR_SUCCESS,
  UPDATE_USER_WORKSHIFT_FAILED,
  UPDATE_USER_WORKSHIFT_SUCCESS,
  WORKSHIFT_BY_EMPLOYER,
  ADD_JOURNAL_DETAIL_SUCCESS,
  ADD_JOURNAL_DETAIL_FAILED,
  DELETE_JOURNAL_SUCCESS,
  GET_JOURNAL_EDIT_SUCCESS,
  CANCEL_JOURNAL_EDIT,
  UPDATE_JOURNAL_DETAIL_SUCCESS,
  UPDATE_JOURNAL_DETAIL_FAILED,
  WORKSHIFT_PAGE_CHANGE,
  SAVE_INVOICE_SUCCESS,
  SAVE_INVOICE_FAILED,
  SET_TOTAL_WORKSHIFTS
} from '../constants'

const initialState = {
  selected: 0,
  employerWorkshiftList: [],
  workShiftUserRow: [],
  billableHourUserRow: [],
  isFilterEmployer: false,
  companySelected: '',
  workshiftsUserFilter: [],
  billableHoursUserFilter: [],
  getWorkshiftUserDataSuccess: false,
  getBillableHourUserDataSuccess: false,
  workshift_journal: [],
  warnDelateJournal: false,
  showSnackbar: false,
  showFailedSnackbar: false,
  showSnackbar_update_workshift: false,
  showFailedSnackbar_update_workshift: false,
  journalAddSnackbar: false,
  journalAddFailedSnackbar: false,
  isEditJournal: false,
  updateJournalSnackbar: false,
  updateJournalFailSnackbar: false,
  workshift_journal_not_attached: [],
  saveDraftInvoiceSuccess: false,
  saveDraftInvoiceFailed: false,
  totalNewWorkshifts: []
}

const workShiftUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOTAL_WORKSHIFTS:
      return Object.assign(
        {},
        { ...state },
        {
          totalNewWorkshifts: action.data
        }
      )
    case WORKSHIFT_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        { selected: action.selected.selected }
      )
    case GET_EMPLOYER_WORKSHIFT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          employerWorkshiftList: action.data
        }
      )

    case GET_WORKSHIFT_USER:
    case GET_BILLABLE_HOUR_USER:
      return Object.assign(
        {},
        { ...state },
        {
          getWorkshiftUserDataSuccess: false,
          getBillableHourUserDataSuccess: false
        }
      )

    case GET_WORKSHIFT_USER_SUCCESS:
      const data = action.data
      const workShiftUserRowData = data.filter(
        (el) =>
          el.workshift_status_entrepreneur !== 3 &&
          el.workshift_status_entrepreneur !== 2
      )
      return Object.assign(
        {},
        { ...state },
        {
          workShiftUserRow: workShiftUserRowData,
          getWorkshiftUserDataSuccess: true
        }
      )
    case GET_BILLABLE_HOUR_USER_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          billableHourUserRow: action.data,
          getBillableHourUserDataSuccess: true
        }
      )

    case GET_JOURNAL_SUCCESS:
      const workshift_journal_data = action.data
      const workshift_journal_not_attached = workshift_journal_data.filter(
        (el) => !el.invoice_id
      )

      return Object.assign(
        {},
        { ...state },
        {
          workshift_journal: formatWorkshiftJournalData(action.data),
          workshift_journal_not_attached: formatWorkshiftJournalData(
            workshift_journal_not_attached
          )
        }
      )

    case GET_JOURNAL_EDIT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          isEditJournal: true
        }
      )

    case CANCEL_JOURNAL_EDIT:
      return Object.assign(
        {},
        { ...state },
        {
          isEditJournal: false
        }
      )

    case ADD_JOURNAL_DETAIL_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          journalAddSnackbar: true,
          journalAddFailedSnackbar: false
        }
      )
    case ADD_JOURNAL_DETAIL_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          journalAddSnackbar: false,
          journalAddFailedSnackbar: true
        }
      )

    case UPDATE_JOURNAL_DETAIL_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          updateJournalSnackbar: true,
          updateJournalFailSnackbar: false,
          isEditJournal: false
        }
      )
    case UPDATE_JOURNAL_DETAIL_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          updateJournalSnackbar: false,
          updateJournalFailSnackbar: true
        }
      )

    case WARN_DELETE_JOURNAL:
      return Object.assign(
        {},
        { ...state },
        {
          warnDelateJournal: true,
          delete_journal_id: action.id
        }
      )

    case DELETE_JOURNAL_SUCCESS:
    case CLOSE_WARN_DELETE_JOURNAL:
      return Object.assign(
        {},
        { ...state },
        {
          warnDelateJournal: false
        }
      )

    case WORKSHIFT_BY_EMPLOYER:
      const companySelected = action.company
      let workshiftsUserFilter, billableHoursUserFilter
      if (companySelected !== '') {
        workshiftsUserFilter = state.workShiftUserRow.filter(
          (item) => item.company_name === companySelected
        )
        billableHoursUserFilter = state.billableHourUserRow.filter(
          (item) => item.company_name === companySelected
        )
      } else {
        workshiftsUserFilter = state.workShiftUserRow
        billableHoursUserFilter = state.billableHourUserRow
      }
      return Object.assign(
        {},
        { ...state },
        {
          isFilterEmployer: true,
          companySelected: action.company,
          workshiftsUserFilter: workshiftsUserFilter,
          billableHoursUserFilter: billableHoursUserFilter
        }
      )

    case UPDATE_USER_WORKSHIFT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar_update_workshift: true,
          showFailedSnackbar_update_workshift: false
        }
      )

    case REQUEST_EDIT_ACTUAL_HOUR_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: true,
          showFailedSnackbar: false
        }
      )

    case UPDATE_USER_WORKSHIFT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar_update_workshift: false,
          showFailedSnackbar_update_workshift: true
        }
      )

    case REQUEST_EDIT_ACTUAL_HOUR_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailedSnackbar: true
        }
      )

    case CLOSE_USER_WORKSHIFT_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailedSnackbar: false,
          showSnackbar_update_workshift: false,
          showFailedSnackbar_update_workshift: false,
          journalAddSnackbar: false,
          journalAddFailedSnackbar: false,
          updateJournalSnackbar: false,
          updateJournalFailSnackbar: false,
          saveDraftInvoiceSuccess: false,
          saveDraftInvoiceFailed: false
        }
      )
    case SAVE_INVOICE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          saveDraftInvoiceSuccess: true
        }
      )
    case SAVE_INVOICE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          saveDraftInvoiceFailed: true
        }
      )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailedSnackbar: false,
          showSnackbar_update_workshift: false,
          showFailedSnackbar_update_workshift: false,
          updateJournalSnackbar: false,
          updateJournalFailSnackbar: false,
          isEditJournal: false,
          selected: 0,
          saveDraftInvoiceSuccess: false,
          saveDraftInvoiceFailed: false
        }
      )

    default:
      return state
  }
}

function formatWorkshiftJournalData(workshift_journal) {
  const result = []
  const journalMap = {}

  workshift_journal.forEach((el) => {
    const {
      journal_itemid,
      journal_id,
      invoice_id,
      shift_date,
      shift_start_time,
      shift_endtime,
      amount,
      comments,
      shift_workedhours,
      sum_total_amount
    } = el

    if (!journalMap[journal_id]) {
      journalMap[journal_id] = {
        journal_id: el.journal_id,
        invoice_id: el.invoice_id,
        status: el.status,
        user_uuid: el.user_uuid,
        task_description: el.task_description,
        totalJournalAmount: el.sum_total_journal_amount,
        created_date: el.created_date,
        dateTimeRows: []
      }
      result.push(journalMap[journal_id])
    }

    journalMap[journal_id].dateTimeRows.push({
      journal_itemid,
      journal_id,
      invoice_id,
      date: shift_date,
      startTime: shift_start_time,
      endTime: shift_endtime,
      amount,
      additionalInfo: comments,
      totalHour: shift_workedhours,
      totalAmount: sum_total_amount
    })
  })

  result.sort((a, b) => new Date(b.created_date) - new Date(a.created_date))

  return result
}

export default workShiftUserReducer
